import React, { useState } from 'react';

const BookCard = ({list, loop=false, onFinish=f=>f})=>{
    const [index, setIndex] = useState(0);
    const totalCount = list.length;

    const onPrev = ()=>{
        if(index>0){
            setIndex( index - 1 );
        }
    }

    const onNext = ()=>{
        if((index+1) < totalCount){
            setIndex( index + 1 );
        }else if(loop){
            setIndex(0);
        }else{
            onFinish();
        }
    };

    const cardList = list.map((item, key)=>{
        const coverImage = (null!==item && item.startsWith('http://') )?`${item}`:item;
        return (
            <div className={`card slide ${key===index?'active':''}`} key={key} id={`bookcard_slide_${key}`}>
                <img src={coverImage} alt="독서카드"/>
            </div>
        )
    });

    return (
        <div className="bookCardContainer">
            <div className="bookCardList" style={{transform : `translateX(${index*-100}%)` }}>
                {cardList}
            </div>
            <div className="controls">
                {index>0 && <button className="btn prev" onClick={onPrev} ></button>}
                <button className="btn next" onClick={onNext} ></button>
            </div>
        </div>
    );
}//end
export default BookCard;